module.exports = {
      id: "fb-blue-usage",
      viewBox: "0 0 28 27.83",
      url: "/" + "sprite-830c6fc89c6e575b53718d760c90aee8.svg#fb-blue",
      toString: function () {
        return this.url;
      }
    }